import { Component, Input, OnInit } from '@angular/core';

import { Observable, map } from 'rxjs';

import { CmsPicture, CmsTarget, CmsTaxonomy } from '@fcom/core-api';
import { AspectRatios } from '@fcom/ui-components';

import { findAspectRatio, toLinkData } from '../../services';

const DEFAULT_RATIO = '16x9';

interface TextOnImageContent {
  picture?: CmsPicture;
  target?: CmsTarget;
  subjectTaxonomyTags?: CmsTaxonomy[];
}

@Component({
  selector: 'cms-text-on-image',
  templateUrl: './cms-text-on-image.component.html',
  standalone: false,
})
export class CmsTextOnImageComponent implements OnInit {
  @Input()
  content$: Observable<TextOnImageContent>;
  @Input()
  noText: boolean;

  imageData$: Observable<CmsPicture>;
  imageAspectRatio$: Observable<keyof typeof AspectRatios>;
  cmsTarget$: Observable<CmsTarget>;

  ngOnInit(): void {
    this.imageData$ = this.content$.pipe(map((d) => d.picture as CmsPicture));
    this.cmsTarget$ = this.content$.pipe(map((d) => toLinkData(d.target)));
    this.imageAspectRatio$ = this.content$.pipe(
      map((d) => findAspectRatio(d.subjectTaxonomyTags ?? []) ?? DEFAULT_RATIO)
    );
  }
}
